// extracted by mini-css-extract-plugin
export default {"hotColor":"#ff229c","warmColor":"#ed6db2","neutralWarmColor":"#fbdded","neutralColdColor":"#daeffc","coldColor":"#acd6f0","veryColdColor":"#2a74a2"};